import { render, staticRenderFns } from "./RegistrationStepSix.vue?vue&type=template&id=55ca0f3e&scoped=true"
import script from "./RegistrationStepSix.vue?vue&type=script&lang=js"
export * from "./RegistrationStepSix.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStepSix.vue?vue&type=style&index=0&id=55ca0f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ca0f3e",
  null
  
)

export default component.exports